import { useLocation } from "@reach/router";
import { toUTCDate } from ".";

export const useDateOverride = (): Date | undefined => {
  const location = useLocation();
  const value = new URLSearchParams(location.search).get("date");
  if (value) {
    const date = toUTCDate(value);
    if (date instanceof Date && !isNaN(date.getTime())) return date;
  }

  return undefined;
};
